import { ApplyRuleOld } from 'mbs-ui-shared@models/remote-deploy/apply-rule-old';
import { ApplyToEnum } from 'mbs-ui-shared@models/remote-deploy/apply-to-enum';
import { OptionsHistory } from 'mbs-ui-shared@models/remote-deploy/options-history';
import { RdConfigOsTypeEnum } from 'mbs-ui-shared@models/remote-deploy/rd-config-os-type.enum';
import { SettingsBackupSymlinksModel } from 'mbs-ui-shared@models/remote-deploy/settings-backup-symlinks-model';
import { SettingsLanguageInterfaceModel } from 'mbs-ui-shared@models/remote-deploy/settings-language-interface-model';
import { SettingsMasterPasswordModel } from 'mbs-ui-shared@models/remote-deploy/settings-master-password-model';
import { SettingsProxyModel } from 'mbs-ui-shared@models/remote-deploy/settings-proxy';
import { WebInterfaceOptions } from 'mbs-ui-shared@models/remote-deploy/web-interface-options';
import { SettingsBandwidthModel } from 'mbs-ui-shared@models/settings-bandwidth-model';

export class RemoteDeployConfiguration {
  additionalOptions: { key: string; value: boolean }[];
  id: string;
  name: string;
  enabled: boolean;
  selectedCompaniesCount: number;
  selectedComputersCount: number;
  selectedTagsCount: number;
  successCount: number;
  failedCount: number;
  pendingCount: number;
  hasNbfPlans: boolean;
  hasFfiPlans: boolean;
  plans: any[];
  planCount: number;
  created: Date;
  applyTo: ApplyToEnum;
  selectedCompanies: string[]; // array of selected companies' Id's
  selectedComputers: string[]; // array of selected computers' Id's
  excludedComputers: string[]; // array of excluded computers' Id's
  selectedTags: number[]; // array of selected tags' Id's
  reapplyTo: string[]; // array of applied computers' Id's
  description: string;
  masterPassword: SettingsMasterPasswordModel;
  readOnly: boolean;
  osType: RdConfigOsTypeEnum;
  bandwidthSettings: SettingsBandwidthModel;
  proxySettings: SettingsProxyModel;
  backupSymlinks: SettingsBackupSymlinksModel;
  languageInterface: SettingsLanguageInterfaceModel;
  webInterfaceOptions: WebInterfaceOptions;
  optionsHistory: OptionsHistory;
  rulesHistory: ApplyRuleOld[];

  constructor(init?: Partial<RemoteDeployConfiguration>) {
    if (init) {
      Object.assign(this, {}, init);
    } else {
      this.name = '';
      this.description = '';
      this.enabled = false;
      this.selectedCompanies = [];
      this.selectedComputers = [];
      this.plans = [];
      this.osType = RdConfigOsTypeEnum.Windows;
      this.applyTo = null;
      this.masterPassword = new SettingsMasterPasswordModel();
      this.bandwidthSettings = new SettingsBandwidthModel();
      this.proxySettings = new SettingsProxyModel();
      this.languageInterface = new SettingsLanguageInterfaceModel();
      this.backupSymlinks = new SettingsBackupSymlinksModel();
      this.optionsHistory = null;
    }
  }
}
